var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-login" }, [
    _c("div", { staticClass: "input-line" }, [
      _c("div", { staticClass: "inout-pram" }, [_vm._v("姓名")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-phone" }, [
        _c("input", {
          attrs: { type: "text", placeholder: "请输入姓名" },
          domProps: { value: _vm.name },
          on: {
            blur: function ($event) {
              return _vm.handelChange(100, "name", $event)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input-line" }, [
      _c("div", { staticClass: "inout-pram" }, [_vm._v("身份证号")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-phone" }, [
        _c("input", {
          attrs: { type: "text", placeholder: "请输入身份证号" },
          domProps: { value: _vm.id_number },
          on: {
            input: function ($event) {
              return _vm.handelChange(18, "id_number", $event)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "input-line" }, [
      _c("div", { staticClass: "inout-pram" }, [_vm._v("手机")]),
      _vm._v(" "),
      _c("div", { staticClass: "input-phone" }, [
        _c("input", {
          attrs: { type: "text", placeholder: "请输入手机号" },
          domProps: { value: _vm.phone },
          on: {
            input: function ($event) {
              return _vm.handelChange(11, "phone", $event)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "span",
      {
        class: ["btn-login", { disable: _vm.isFromDisable }],
        on: { click: _vm.registered },
      },
      [_vm._v("重新绑定")]
    ),
    _vm._v(" "),
    _c("div"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }